import React, { ComponentPropsWithoutRef, ReactNode } from 'react';
import { clsx } from 'clsx';

import styles from './ButtonGroup.module.scss';

export interface ButtonGroupProps extends ComponentPropsWithoutRef<'div'> {
  children: ReactNode;
  className?: string;
}

export const ButtonGroup = ({
  children,
  className,
  ...otherProps
}: ButtonGroupProps) => {
  return (
    <div className={clsx(styles.buttonGroup, className)} {...otherProps}>
      {children}
    </div>
  );
};
